import request from '@/axios/index.js'
const center = '/user/center/';

export function getUserInfoApi(data) {
    return request.axios({
        url: center+'getUserInfo'
    })
}
export function goldTicketApi(data) {
    return request.axios({
        url: center+'receivableAndPayable/goldTicket'
    })
}
export function backlogApi(data) {
    return request.axios({
        url: center+'items/backlog'
    })
}
export function expirApi(data) {
    return request.axios({
        data:data,
        url: center+'items/expire'
    })
}
export function getLinesApi(data) {
    return request.axios({
        data:data,
        url: center+'getLines'
    })
}
export function getCstIds(data) {
    return request.axios({
        data:data,
        url: center+'getCstIds'
    })
}
// 获取系统节假日
export function queryByDate(data) {
  return request.axios({
      data:data,
      type:'get',
      url: '/user/holMgtList/queryByDate'
  })
}



// WEBPACK FOOTER //
// ./src/api/center.js